import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import Styles from "./links.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

class Link extends C {
  static dynamicStyles = null
  static displayName = "Link_EAs"
  static propTypes = {
    href: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    dataQa: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    "data-info-link-id": PropTypes.string,
    notDecorate: PropTypes.bool,
    title: PropTypes.string,
  }

  static defaultProps = {
    notDecorate: false,
  }

  constructor(props) {
    super(props)

    if (Link.dynamicStyles == null) {
      const dynamicStylesConfig = toJss(props.skinObject.link || {}, {
        easLink: {
          color: v.blue300,
          pm_hover: {
            color: v.blue400,
          },
        },
      })

      Link.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  getClass() {
    let { classes } = Link.dynamicStyles

    return classNames(Styles.easLink, classes.easLink, this.props.className, {
      [Styles.disabled]: this.props.disabled,
      [Styles.decorate]: !this.props.notDecorate,
      [Styles.notDecorate]: this.props.notDecorate,
    })
  }

  render() {
    return (
      <a
        target={this.props.target}
        href={this.props.href}
        title={this.props.title}
        onClick={this.props.onClick}
        className={this.getClass()}
        disabled={this.props.disabled}
        data-qa={this.props.dataQa}
        id={this.props.id}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        data-info-link-id={this.props["data-info-link-id"]}>
        {this.props.children}
      </a>
    )
  }
}

export default withSkin(Link)
